const autoNgTemplateLoaderTemplate1 = require('./registry-form-custom.html');

angular.module('shbdeployer.app').component('registryFormCustom', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    model: '=',
    formAction: '<',
    formActionLabel: '@',
    actionInProgress: '<',
  },
});
